const state = {
    renewPopShow: true,
    fiveOpenList: []
}
const mutations = {
    SET_RENEWPOPSHOW: (state, Bln) => {
        state.renewPopShow = Bln
    },
    SET_FIVEOPENLIST: (state, cover) => {
        state.fiveOpenList = cover
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}